<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-primary">{{ icons.arrowLeft }}</v-icon>
        <router-link
          class="text-decoration--none"
          :to="{ name: 'reviews.listing' }"
          >Reviews</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4" v-if="form">
      <div class="display-2 font-weight-bold my-6 text-capitalize">
        Review Details
      </div>

      <!-- Review Form -->
      <div class="col-md-4 col-sm-12 col-xs-12 mt-6 pa-0">
        <v-form ref="form" v-if="form" class="place-form">
          <h3 class="py-5 primary--text">Review Information</h3>

          <label class="text-field-label">Rating</label>
          <v-text-field
            flat
            solo
            required
            class="mt-2"
            v-model="form.rating"
            :error-messages="form.$getError('rating')"
            :loading="loading"
          ></v-text-field>

          <label class="text-field-label">Review</label>
          <v-text-field
            flat
            solo
            required
            class="mt-2"
            v-model="form.review"
            :error-messages="form.$getError('review')"
            :loading="loading"
          ></v-text-field>

          <h3 class="py-5 primary--text">Media Information</h3>
          <review-photos
            :media="review.photos"
            :mediaLoading="mediaLoading"
            updateImage
            @delete="removeMedia"
          />
        </v-form>
      </div>
      <!-- End of Review Form -->
    </div>
  </div>
</template>

<script>
import ControlsMixin from '@/utils/mixins/Controls'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import ReviewPhotos from './components/ReviewPhotos'
import { mdiChevronLeft } from '@mdi/js'

import Form from '@/utils/form'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ReviewDetails',

  mixins: [ControlsMixin],

  components: {
    AppBarNavIcon,
    ReviewPhotos
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft
      },
      form: true,
      mediaLoading: false
    }
  },

  computed: {
    ...mapState({
      review: state => state.review.reviewDetails
    })
  },

  created() {
    this.form = new Form(this.review)
    this.getReview()
  },

  methods: {
    ...mapActions({
      getReviewDetails: 'review/getReviewDetails'
    }),

    async getReview() {
      this.loading = true
      await this.getReviewDetails(this.$route.params.id)
      this.form = new Form(this.review)
      this.loading = false
    },

    removeMedia(mediaId) {
      this.imageId = mediaId
    }
  }
}
</script>
